// extracted by mini-css-extract-plugin
module.exports = {"lia-meta":"UserDetails_lia-meta__OKwUK","lia-info":"UserDetails_lia-info__FPfyf","lia-count":"UserDetails_lia-count__DcEyK"};